import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import ScoreCard from "./components/ScoreCard";
import {
  CheckCircle,
  XCircle,
  Home,
  Volume2,
  VolumeX,
  Play,
  Pause,
  Lightbulb,
} from "lucide-react";
import useTimer from "./hooks/useTimer";
/*
API Key: vetri_kuralattam_XKokBfNWv6FIYuTMg5sLPjhJ
kural
kural@2025

curl -X POST https://vetriacademy.in/api/api.php -H "Content-Type: application/json" -d '{
  "no_of_kural": 5,
  "game_time": 10,
  "titile": "புதிய வகுப்பு",
  "athikaram": ["புதிய பாடம்"],
  "gradient": "bg-gradient-to-r from-red-500 to-blue-500",
  "isGameDisabled": false,
  "game_level": 1,
  "datafile": ""
}'

*/
const shuffleArray = (array) => {
  return [...array].sort(() => Math.random() - 0.5);
};

const CustomButton = ({
  onClick,
  children,
  className,
  disabled,
  isShuffling,
}) => (
  <motion.button
    disabled={disabled}
    initial={{ opacity: 0, scale: 0.5 }}
    //animate={{ opacity: 1, scale: 1 }}
    animate={{
      opacity: isShuffling ? [0, 1] : 1,
      scale: isShuffling ? [0.8, 1] : 1,
    }}
    transition={{ duration: 0.4 }}
    whileTap={{ scale: 0.9 }}
    onClick={onClick}
    className={`px-2 py-1 lg:py-2 rounded text-white text-lg lg:text-2xl cursor-pointer bg-gradient-to-r from-fuchsia-500 to-pink-500 border-2 border-fuchsia-600  ${className}`}
  >
    {children}
  </motion.button>
);

export default function Kuralattam1() {
  const navigate = useNavigate();
  const location = useLocation();
  const [shuffledWords, setShuffledWords] = useState([]);
  const [userSentence, setUserSentence] = useState([]);
  const [correctSentences, setCorrectSentences] = useState([]);
  const [score, setScore] = useState(0);
  const [wordScore, setWordScore] = useState(0);
  const [hintIndex, setHintIndex] = useState(null);
  const [givenGameTime, setGivenGameTime] = useState(10);
  const [isGameOver, setIsGameOver] = useState(false);
  const [isShuffling, setIsShuffling] = useState(false);
  const [isMute, setIsMute] = useState(true);
  const [data, setData] = useState([]);
  const [endTime, setEndTime] = useState("");
  const [startTime, setStartTime] = useState("");
  const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);

  const [myscore, setMyscore] = useState({
    correctSentences: 0,
    correctWords: 0,
    startTime: null,
    endTime: null,
    gameid: null,
  });
  //const [sentenceStatus, setSentenceStatus] = useState([]); // New state to track sentence status
  // Replace timer-related state and functions with custom hook
  const {
    timeLeft,
    timerActive,
    startTimer,
    pauseTimer,
    resetTimer,
    stopTimer,
    formatTime,
  } = useTimer(300); // 5 minutes = 300 seconds
  //----------------------------------------
  // Load sounds for correct and incorrect actions
  const correctSound = new Audio("/sounds/correct.mp3");
  const incorrectSound = new Audio("/sounds/incorrect.mp3");

  const calculateTimeTaken = () => {
    const totalTime = givenGameTime * 60;
    const timeTaken = totalTime - timeLeft;
    return formatTime(timeTaken);
  };
  const handleRestartGame = () => {
    navigate("/aattam");
  };

  // Add effect to handle game over
  useEffect(() => {
    if (timeLeft === 0 && !isGameOver) {
      const now = new Date();
      const formattedEndDate =
        now.toISOString().slice(0, 19).replace("T", " ") +
        "." +
        now.getMilliseconds().toString().padStart(3, "0");
      setEndTime(formattedEndDate);
      console.log("EndTime:", formattedEndDate);

      setIsGameOver(true);
      stopTimer();
    }
  }, [timeLeft, isGameOver, stopTimer]);

  const muteSound = () => {
    setIsMute((prev) => !prev);
  };
  const handleHome = () => {
    navigate("/aattam");
  };

  // Modify the useEffect where the game starts
  useEffect(() => {
    const mydata = location.state.data;
    const time = location.state.time;
    const no = location.state.number;
    const titile = location.state.titile;
    const gameid = location.state.gameid;
    console.log("no ", no);
    console.log("time ", time);
    console.log("titile ", titile);
    console.log("mydata ", mydata);
    console.log("gameid ", gameid);
    setMyscore((prevScore) => ({
      ...prevScore,
      gameid: gameid,
    }));
    setGivenGameTime(time);
    resetTimer(time * 60);
    setData(mydata);

    // Set start time with milliseconds
    const now = new Date();
    const formattedDate =
      now.toISOString().slice(0, 19).replace("T", " ") +
      "." +
      now.getMilliseconds().toString().padStart(3, "0");
    setStartTime(formattedDate);
    console.log("StartTime:", formattedDate);
    setMyscore((prevScore) => ({
      ...prevScore,
      startTime: new Date().toISOString().slice(0, 19).replace("T", " "),
    }));
    startTimer();
    loadNewWords(mydata);
  }, [location, resetTimer, startTimer]);

  const loadNewWords = (mdata) => {
    if (mdata.length > 0) {
      const allWords = mdata.flatMap((item) => item.kural.join(" ").split(" "));
      // .map((word) => word.replace(/\./g, "")); // Remove all periods from words
      setShuffledWords(shuffleArray(allWords));
      setUserSentence([]);
      setHintIndex(null);
      setCurrentSentenceIndex(0);
    }
  };

  const handleWordClick = (wordIndex) => {
    if (!isGameOver && timerActive && userSentence.length < 7) {
      const word = shuffledWords[wordIndex];
      const newSentence = [...userSentence, word];
      setUserSentence(newSentence);
      let shuffled = shuffledWords.filter((_, index) => index !== wordIndex);
      setShuffledWords(shuffled);
      setHintIndex(null);
      if (isWordCorrect(newSentence)) {
        setWordScore((prevWordScore) => prevWordScore + 1);
        setMyscore((prevScore) => ({
          ...prevScore,
          correctWords: prevScore.correctWords + 1,
        }));

        if (!isMute) correctSound.play();
      } else {
        if (!isMute) incorrectSound.play();
      }

      if (newSentence.length === 7) {
        // Increment the current sentence index
        setCurrentSentenceIndex((prevIndex) => prevIndex + 1);
        setShuffledWords(shuffleArray(shuffled));
        checkSentence(newSentence, shuffled);
      }
    }
  };

  const isWordCorrect = (currentSentence) => {
    const joinedSentence = currentSentence.join(" ");
    return data.some((item) => item.kural.join(" ").startsWith(joinedSentence));
  };

  const handleHint = () => {
    if (userSentence.length === 0) {
      for (let item of data) {
        const firstWord = item.kural.join(" ").split(" ")[0];
        const firstWordIndex = shuffledWords.findIndex(
          (word) => word === firstWord
        );
        if (firstWordIndex !== -1) {
          setHintIndex(firstWordIndex);
          return;
        }
      }
    } else {
      const currentSentence = userSentence.join(" ");
      const correctSentence = data.find((item) =>
        item.kural.join(" ").startsWith(currentSentence)
      );
      if (correctSentence) {
        const correctWords = correctSentence.kural.join(" ").split(" ");
        const nextWordIndex = shuffledWords.findIndex(
          (word) => word === correctWords[userSentence.length]
        );
        setHintIndex(nextWordIndex !== -1 ? nextWordIndex : null);
      }
    }
  };
  const resetGame = () => {
    setIsShuffling(true);
    setTimeout(() => {
      const allWords = data.flatMap((item) => item.kural.join(" ").split(" "));
      setShuffledWords(shuffleArray(allWords));
      setUserSentence([]);
      setCorrectSentences([]);
      setHintIndex(null);
      setIsGameOver(false);
      stopTimer();
      setIsShuffling(false);
      resetTimer(300);
      startTimer();
      setScore(0);
      setWordScore(0);
    }, 300);
  };
  const handleReset = () => {
    resetGame();
  };

  // Also add end time logging in checkSentence when game completes
  const checkSentence = (currentSentence, shuffled) => {
    const joinedSentence = currentSentence.join(" ");

    const isCorrect = data.some(
      (item) => item.kural.join(" ") === joinedSentence
    );
    setCorrectSentences([
      ...correctSentences,
      { sentence: joinedSentence, isCorrect },
    ]);

    console.log("Current Kural", data[currentSentenceIndex]);

    console.log("joinedSentence", joinedSentence);
    if (isCorrect) {
      setScore((prevScore) => prevScore + 1);
    }
    setMyscore((prevScore) => ({
      ...prevScore,
      correctSentences: prevScore.correctSentences + (isCorrect ? 1 : 0),
    }));
    setUserSentence([]);

    if (shuffled.length === 0) {
      const now = new Date();
      const formattedEndDate =
        now.toISOString().slice(0, 19).replace("T", " ") +
        "." +
        now.getMilliseconds().toString().padStart(3, "0");
      setEndTime(formattedEndDate);
      console.log("EndTime:", formattedEndDate);

      setIsGameOver(true);
      stopTimer();
    } else {
      setIsShuffling(true);
      setTimeout(() => {
        setIsShuffling(false);
      }, 300);
    }
  };

  return (
    <>
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-[60%_40%] md:grid-cols-[65%_35%] lg:grid-cols-[70%_30%] gap-3">
          <div className="bg-gradient-to-r from-indigo-500 via-blue-500 to-cyan-500 p-4 rounded relative">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-white hidden lg:block ">
                குறளாட்டம் இரணடாம் நிலை
              </h2>
              <div className="flex space-x-2">
                {!isGameOver && (
                  <>
                    <button
                      onClick={handleReset}
                      className=" bg-red-500 px-4 py-2 rounded text-white text-xl hidden "
                    >
                      Reset
                    </button>
                    <button
                      onClick={handleHint}
                      className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-green-600"
                    >
                      <Lightbulb size={24} className="sm:block" />
                      <span className="hidden sm:inline">Hint</span>
                    </button>

                    <button
                      className="  hidden items-center gap-2   bg-yellow-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-yellow-600"
                      onClick={pauseTimer}
                    >
                      {!timerActive ? (
                        <Play size={24} className="sm:block" />
                      ) : (
                        <Pause size={24} className="sm:block" />
                      )}
                      <span className="hidden sm:inline">
                        {!timerActive ? "Play" : "Pause"}
                      </span>
                    </button>

                    <button
                      className="flex items-center gap-2 bg-gray-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-gray-600"
                      onClick={muteSound}
                    >
                      {isMute ? (
                        <VolumeX size={24} className="sm:block" />
                      ) : (
                        <Volume2 size={24} className="sm:block" />
                      )}
                      <span className="hidden sm:inline">
                        {isMute ? "Unmute" : "Mute"}
                      </span>
                    </button>
                  </>
                )}

                <button
                  onClick={handleHome}
                  className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-blue-600"
                >
                  <Home size={24} className="sm:block" />
                  <span className="hidden sm:inline">Home</span>
                </button>
              </div>
            </div>
            {isGameOver && (
              <>
                <div className="">
                  <div className="text-center">
                    <h2 className="text-3xl text-yellow-200 font-semibold mb-4">
                      Game Over!
                    </h2>
                    <h2 className="text-2xl text-yellow-400 font-semibold mb-4">
                      Time's up or you've completed all sentences.
                    </h2>
                  </div>
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ rotate: 360, scale: 1 }}
                    transition={{
                      type: "spring",
                      stiffness: 260,
                      damping: 20,
                    }}
                  >
                    <ScoreCard
                      correctSentences={score}
                      correctWords={wordScore}
                      timeTaken={calculateTimeTaken()}
                      timeRemining={formatTime(timeLeft)}
                      handleRestart={handleRestartGame}
                      startTime={startTime}
                      endTime={endTime}
                    />
                  </motion.div>
                </div>
              </>
            )}
            {!isGameOver && (
              <div className="space-y-4">
                <div className="border p-4 rounded  border-blue-300 bg-gradient-to-r from-blue-200 to-cyan-200 ">
                  <>
                    <h3 className="font-semibold mb-2 text-xl">
                      கலைக்கப்பட்ட குறள்கள்
                    </h3>
                    <div className={`flex flex-wrap gap-2`}>
                      {shuffledWords.map((word, index) => (
                        <CustomButton
                          disabled={isGameOver}
                          isShuffling={isShuffling}
                          key={index}
                          onClick={() => handleWordClick(index)}
                          className={` ${
                            hintIndex === index
                              ? "bg-gradient-to-r from-green-400 to-blue-500"
                              : ""
                          } `}
                        >
                          <span
                            className={`${!timerActive ? "blur-[5px]" : ""}`}
                          >
                            {word}
                          </span>
                        </CustomButton>
                      ))}
                    </div>
                    <h2>{shuffledWords.length}</h2>
                    <div className="border p-4 rounded bg-gray-100">
                      <h3 className="font-semibold mb-2 text-xl">
                        அடுக்கப்பட்ட குறள்
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {userSentence.map((word, index) => {
                          const isCorrect = isWordCorrect(
                            userSentence.slice(0, index + 1)
                          );
                          return (
                            <motion.span
                              initial={{ opacity: 0, scale: 0.5 }}
                              animate={{ opacity: 1, scale: 1 }}
                              transition={{ duration: 0.3 }}
                              key={index}
                              className={`p-2 rounded text-white ${
                                isCorrect ? "bg-green-500" : "bg-red-500"
                              }`}
                            >
                              {word}
                            </motion.span>
                          );
                        })}
                      </div>
                    </div>
                  </>
                </div>
              </div>
            )}
          </div>

          <div className="bg-gradient-to-bl from-[#84cc16] via-[#16a34a] to-[#0f766e] rounded  p-4 relative">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-white">Score</h2>
            </div>
            <div className="space-y-4">
              <div className="border p-4 rounded bg-gray-100">
                <h3 className="text-red-500 font-bold">
                  Time Left: {Math.floor(timeLeft / 60)}:
                  {(timeLeft % 60).toString().padStart(2, "0")}
                </h3>
                <h3 className="font-semibold">
                  Time Taken: {calculateTimeTaken()}
                </h3>
                <h3 className="font-semibold">Sentence Score: {score}</h3>
                <h3 className="font-semibold">Word Score: {wordScore}</h3>
              </div>

              <div className="border p-4 rounded bg-gray-100">
                <h3 className="font-semibold">Completed Sentences</h3>
                <ul>
                  {correctSentences.map((entry, index) => (
                    <>
                      <li
                        key={index}
                        className="flex items-center gap-4 p-2 border rounded-lg shadow-md"
                      >
                        {entry.isCorrect ? (
                          <CheckCircle className="text-green-500" size={20} />
                        ) : (
                          <XCircle className="text-red-500" size={20} />
                        )}
                        <p className="text-gray-700 whitespace-pre-line text-l font-bold">
                          {entry.sentence.split(" ").slice(0, 4).join(" ") +
                            "\n" +
                            entry.sentence.split(" ").slice(4).join(" ")}
                        </p>
                      </li>
                    </>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
